import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SidebarService } from '../../service/sidebar.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  model: any;
  selectedCount: number = 0;
  ballotList = [];
  totalContest: number = 0;
  @Input() contestList = [];
  @Output() sideBarEvent = new EventEmitter();
  @Input() countVotes: any;
  @Input() totalContests: number;
  @Input() totalCompleted: number;

  constructor(public sidebarService: SidebarService) {

  }

  ngOnInit() {
    this.ballotList = this.sidebarService.getContest();
  }

}



// WEBPACK FOOTER //
// ./src/app/features/sidebar/sidebar.component.ts